import { IStudentToSelect } from 'pages/Feed/interfaces'
import { Dispatch, SetStateAction } from 'react'

export interface IStudentItem {
  selectedStudent: IStudentToSelect
  setStudents: Dispatch<SetStateAction<IStudentToSelect[]>>
}
